import * as React from 'react';
import { NavLink } from "react-router-dom";
import { observer, inject } from "mobx-react";
import PeopleIcon from '@material-ui/icons/People';
import ListIcon from '@material-ui/icons/List';
import InfiniteScroll from 'react-infinite-scroll-component';

// =====================================
// CONSTS
import { Messages } from '../../const/Messages';

// =====================================
// STORES
import { ICustomerStore } from '../../store/CustomerStore';
import { ILoginStore } from '../../store/LoginStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';
import { SearchHeader } from '../Layout/SearchHeader';
import { Loader } from '../Layout/Loader';

@inject((allStores: any) => ({
    customerStore: allStores.store.customerStore as ICustomerStore,
    loginStore: allStores.store.loginStore as ILoginStore
}))

@observer
export default class Pricelist extends React.Component<{ customerStore?: ICustomerStore, loginStore?: ILoginStore }, any> {

    componentDidMount() {
        this.props.customerStore.getPricelist();
    }

    componentWillUnmount() {
        this.props.customerStore.reset();
    }

    render() {

        let headerComponent: any = null;
        if (!this.props.customerStore.isSearchHeaderVisible) {
            headerComponent =
                <Header
                    title='mKomercijalista'
                    isSearchButtonVisible={true}
                    searchAction={this.props.customerStore.showSearchHeaderForPricelist} />
        } else {
            headerComponent =
                <SearchHeader
                    samePageAction={this.props.customerStore.hideSearchHeader}
                    clearAction={this.props.customerStore.clearArticleSearch}
                    keyword={this.props.customerStore.keyword}
                    onHandleSearch={this.props.customerStore.handleArticleSearch} />
        }

        return (
            <div>
                {headerComponent}

                <div className="container customer-wrapper">
                    {!this.props.customerStore.isLoading ?
                        <div>
                            {!this.props.customerStore.isSearchEmpty ?
                                // <InfiniteScroll
                                //     dataLength={this.props.customerStore.articlesPricelist.length}
                                //     next={this.props.customerStore.fetchMorePricelist}
                                //     hasMore={this.props.customerStore.hasMoreArticlesToLoad}
                                //     endMessage={<div className="infinitescroll_msg">Svi artikli su učitani.</div>}
                                //     loader={<div className="infinitescroll_msg">Učitavamo podatke...</div>}>
                                <div>
                                    {this.props.customerStore.articlesPricelist.map((item, i) => {
                                        return <div className="pricelist-container" key={i}>
                                            <div className="product">
                                                <div className="product-name">{item.name} - {item.unitOfMeasurement}</div>
                                                <div>Šifra: {item.code}</div>
                                                <div>Cena: {item.acquisitionPrice.toLocaleString("sr", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} RSD</div>
                                            </div>
                                        </div>
                                    })}</div>
                                // </InfiniteScroll>
                                : <div className="no_data">{Messages.ARTICLES_SEARCH_EMPTY + this.props.customerStore.keyword}</div>}
                        </div> : <Loader />}
                </div>

                <div className="footer-icon-container">
                    <NavLink className="footer-icon col-6" to={"/customers"}>
                        <PeopleIcon />
                        <div>Klijenti</div>
                    </NavLink>
                    <NavLink className="footer-icon col-6" to={"/pricelist"}>
                        <ListIcon />
                        <div>Cenovnik</div>
                    </NavLink>
                </div>
            </div >
        );
    }
}